import Login from './login';
import Projects from './projects/Projects';
import profile from './settings/profile';
import Invoice from './projects/invoice/invoicejobs';
import PaidInvoices from './projects/invoice/paidInvoices';
import PendingInvoicesToSend from './projects/invoice/pendingInvoicesToSend';
import InvoiceMaster from './projects/invoice/invoicemaster';
import Users from './userManagement/listUsers';
import MapDesignations from './userManagement/mapDesignations';
import UserLogins from './userManagement/usersLogins';
import Leaves from './Leaves';
import Access from './userManagement/access/index';
import Routings from './userManagement/routes/routingMap';
import * as action from './../actions/auth';
import forgotPassword from './forgotPassword';
import SortlistedCandidates from './hrm/pre-onboardig/sortlistedCandidates';
import FixedBidInvoice from './projects/invoice/fixedBidInvoice';
import EmailTemplates from './CMS/emailTemplates';
import EmailKeysMaps from './CMS/emailKeysMaps';
import InvoiceReports from './projects/invoice/invoiceReports';
import CreatePages from './CreatePages/index';
import BulkMails from './hrm/bulk-mail/index';
import Policy from './company/policy/index';
import PolicyCategory from './company/PolicyCategory';
import UserPolicy from './company/userPolicy/index';
import Clients from './clients/index';
import GenrateSalarySlip from './hrm/salarySlip/index';
import Departments from './userManagement/department';
import Releaving from './hrm/Exits/releaving/index';
import Experiance from './hrm/Exits/experiance/index';
import Resumes from './CMS/resumes';
import EmployeeProjects from './CMS/employeeProjects';
import SendCV from './clients/sendCV';
import CurrentOpenings from './Jobs/index';
import AvailableSlots from './Jobs/available-slots/index';
import BulkMailVender from './hrm/bulk-mail-vender/index';
import Files from './hrm/files/index';
import TeamManagment from './projects/Teams/ProjectTeams';

import ProjectDashboard from './projects/ProjectDashboard/ProjectDashboard';
import OfferLetterTemplate from './hrm/OfferLetterTemplate';
import Welcome from './home/Welcome';
import Dashboard from './home/Dashboard';
import candidates from './hrm/pre-onboardig/tabs/candidates/candidates';
import Screening from './hrm/pre-onboardig/tabs/Screening';
import HrRound from './hrm/pre-onboardig/tabs/HrRound';
import LevelOne from './hrm/pre-onboardig/tabs/LevelOne';
import LevelTwo from './hrm/pre-onboardig/tabs/LevelTwo';
import LevelThree from './hrm/pre-onboardig/tabs/LevelThree';
import LevelFour from './hrm/pre-onboardig/tabs/LevelFour';
import ManagerRound from './hrm/pre-onboardig/tabs/ManagerRound';
import SalaryRound from './hrm/pre-onboardig/tabs/SalaryRound';
import PreOnboarding from './hrm/pre-onboardig/onboarding/pre-onboarding/PreOnboarding';
import OfferLetter from './hrm/pre-onboardig/onboarding/offers/OfferLetter';
import OrganizationSummary from './Organization/Dashboard/Summary';
import OrganizationTree from './Organization/Employees/OrganizationTree';
import OrganizationAnalysis from './Organization/Dashboard/Analysis';
import EmployeeDirectory from './Organization/Employees/EmployeeDirectory/EmployeeDirectory';
import LoginFailed from './Organization/Employees/Login/LoginFailed';
import LoginHistory from './Organization/Employees/Login/LoginHistory';
import LoginRegistration from './Organization/Employees/Login/LoginRegistration';
import ContingentSummary from './Organization/Employees/ContingentStaff/Summary';
import WorkType from './Organization/Employees/ContingentStaff/WorkTypes/WorkType';
import DottedLineManager from './Organization/Employees/Settings/DottedLineManager';
import EmployeeDefaults from './Organization/Employees/Settings/EmployeeDefaults';
import EmployeeNumber from './Organization/Employees/Settings/EmployeeNumber';
import IDCard from './Organization/Employees/Settings/IDCard';
import Roles from './Organization/Employees/Settings/Roles';
import PersonalInfo from './Organization/Employees/Settings/PersonalInfo';
import Wall from './Organization/Employees/Settings/Wall';
import EmployeeTimeline from './Organization/Employees/Settings/Timeline';
import ProfilesApprovals from './Organization/Employees/ProfileChanges/ProfilesApprovals';
import PastChanges from './Organization/Employees/ProfileChanges/PastChanges';
import CompleteProbationAction from './Organization/Employees/Probation/CompleteProbationAction';
import EvaluationInProcess from './Organization/Employees/Probation/EvaluationInProcess';
import InProbation from './Organization/Employees/Probation/InProbation';
import ProbationFeedbackForm from './Organization/Employees/Probation/ProbationFeedbackForm';
import ProbationPolicy from './Organization/Employees/Probation/ProbationPolicy';
import PrivateProfiles from './Organization/Employees/PrivateProfiles/PrivateProfiles';
import ApprovalLeaves from './TimeandAttendance/Approvals/ApprovalLeaves';
import CompOffs from './TimeandAttendance/Approvals/CompOffs';
import LeaveEncashment from './TimeandAttendance/Approvals/LeaveEncashment';
import Overtime from './TimeandAttendance/Approvals/Overtime';
import PartialDay from './TimeandAttendance/Approvals/PartialDay';
import Regularization from './TimeandAttendance/Approvals/Regularization';
import ShiftandWeeklyOff from './TimeandAttendance/Approvals/ShiftandWeeklyOff';
import WebClockIn from './TimeandAttendance/Approvals/WebClockIn';
import WfhOD from './TimeandAttendance/Approvals/WfhOD';
import BulkRegularization from './TimeandAttendance/AttendanceTracking/BulkRegularization';
import CaptureScheme from './TimeandAttendance/AttendanceTracking/CaptureScheme';
import CaptureSchemeAllocation from './TimeandAttendance/AttendanceTracking/CaptureSchemeAllocation';
import TrackingPolicy from './TimeandAttendance/AttendanceTracking/TrackingPolicy';
import TrackingPolicyAllocation from './TimeandAttendance/AttendanceTracking/TrackingPolicyAllocation';
import LeastHourWorked from './TimeandAttendance/Dashboard/AttendanceAnalytics/LeastHourWorked';
import MostHourWorked from './TimeandAttendance/Dashboard/AttendanceAnalytics/MostHourWorked/MostHourWorked';
import MostBreakTaken from './TimeandAttendance/Dashboard/AttendanceAnalytics/MostBreakTaken';
import OvertimeHours from './TimeandAttendance/Dashboard/AttendanceAnalytics/OvertimeHours';
import LeaveBalanceAvailable from './TimeandAttendance/Dashboard/LeaveAnalytics/LeaveBalanceAvailable';
import MostLeaveTaken from './TimeandAttendance/Dashboard/LeaveAnalytics/MostLeaveTaken';
import UnplanedLeaveTaken from './TimeandAttendance/Dashboard/LeaveAnalytics/UnplanedLeaveTaken';
import AttendanceSummary from './TimeandAttendance/Dashboard/AttendanceSummary/AttendanceSummary';
import LeaveSummary from './TimeandAttendance/Dashboard/LeaveSummary';
import IntialAdjustments from './TimeandAttendance/Leave/intialAdjustments';
import LeavePlans from './TimeandAttendance/Leave/LeavePlans/LeavePlans';
import LeaveTypes from './TimeandAttendance/Leave/LeaveTypes';
import OvertimePolicy from './TimeandAttendance/Overtime/OvertimePolicy';
import OvertimePolicyAllocations from './TimeandAttendance/Overtime/OvertimePolicyAllocations';
import PayCodes from './TimeandAttendance/Overtime/PayCodes';
import LeaveReports from './TimeandAttendance/Reports/LeaveReports';
import DeviceClockingSummary from './TimeandAttendance/Settings/DeviceClocking/DeviceClockingSummary';
import SyncToolsInstallations from './TimeandAttendance/Settings/DeviceClocking/SyncToolsInstallations';
import Employees from './TimeandAttendance/Settings/GeoLocations/Employees';
import GeoLocations from './TimeandAttendance/Settings/GeoLocations/GeoLocations';
import General from './TimeandAttendance/Settings/General';
import ShiftAllowanceAssigment from './TimeandAttendance/WeeklyOffs/Assigment/ShiftAllowanceAssigment';
import ShiftWeeklyOffRulesAssignments from './TimeandAttendance/WeeklyOffs/Assigment/ShiftWeeklyOffRulesAssignments';
import ShiftWeeklyOffsAssigment from './TimeandAttendance/WeeklyOffs/Assigment/ShiftWeeklyOffsAssigment';
import ShiftBoard from './TimeandAttendance/WeeklyOffs/Schedulers/ShiftBoard';
import ShiftRotation from './TimeandAttendance/WeeklyOffs/Schedulers/ShiftRotation';
import ShiftAllowanceCode from './TimeandAttendance/WeeklyOffs/ShiftAllowances/ShiftAllowanceCode';
import ShiftAllowancePolicy from './TimeandAttendance/WeeklyOffs/ShiftAllowances/ShiftAllowancePolicy';
import Shifts from './TimeandAttendance/WeeklyOffs/ShiftAndWeeklyOffs/Shifts';
import ShiftWeeklyOffRules from './TimeandAttendance/WeeklyOffs/ShiftAndWeeklyOffs/ShiftWeeklyOffRules';
import WeeklyOffs from './TimeandAttendance/WeeklyOffs/ShiftAndWeeklyOffs/WeeklyOffs';
import AttendanceCaptureScheme from './Organization/Employees/ExtraSettings/AttendanceCaptureScheme';
import AttendanceNumber from './Organization/Employees/ExtraSettings/AttendanceNumber';
import AttendanceTrackingPolicy from './Organization/Employees/ExtraSettings/AttendanceTrackingPolicy';
import BusinessUnit from './Organization/Employees/ExtraSettings/BusinessUnit';
import ExpencesPolicy from './Organization/Employees/ExtraSettings/ExpencesPolicy';
import HolidayList from './TimeandAttendance/WeeklyOffs/Holidays/HolidayList';
import LegalEntity from './Organization/Employees/ExtraSettings/LegalEntity';
import Locations from './Organization/Employees/ExtraSettings/Locations';
import NoticePeriod from './Organization/Employees/ExtraSettings/NoticePeriod';
import TaxRegime from './Organization/Employees/ExtraSettings/TaxRegime';
import TimeType from './Organization/Employees/ExtraSettings/TimeType';
import ProjectTeams from './projects/Teams/ProjectTeams';
import ProjectTask from './projects/dashboard/tasks';
import { PayRollRoutes } from './PayRoll';
import { HRMRoutes } from './hrm';
import Organization from './Organization/Organization';
import { MyFinanceRoutes } from './MyFinance';
import EmailTemplateMapping from './CMS/TemplateMapping';
import JobOpenings from './public/openings/JobOpenings';
import JobDetials from './public/openings/JobDetials';
import Documents from './public/onboarding/doccuments';
import Leads from './Leads';
import Instructions from './OnlineTest/Instructions';
import JobId from './Jobs/JobId';
import OnlineExamRoutes from './OnlineTest/Online.routes';
import TestComponent from './hrm/pre-onboardig/tabs/Tests/TestComponent';
import AllTest from './hrm/pre-onboardig/tabs/Tests/AllTest';
import FailedTest from './hrm/pre-onboardig/tabs/Tests/FailedTests';
import CompletedTest from './hrm/pre-onboardig/tabs/Tests/CompletedTest';
import QualifiedCandidates from './hrm/pre-onboardig/tabs/Tests/QualifiedCandidates';
import WorkflowList from './Workflow/WorkFlowList';
import WorkFlowRoutes from './Workflow';
import VendoRegistrationForm from './vendor/VendoRegistrationForm';
import SuccessMessage from './Messages/SuccessMessage';
import { VendorRoutes } from './vendor';
import LoginCandidate from './public/onboarding/LoginCandidate';
import TimesheetForm from './public/timesheet/TimesheetForm';
import TimesheetMain from './public/timesheet';
import OnlyOfficeFileEditor from './OnlyOfficeFileEditor';
import { PerformanceRoutes } from './Performance';
import Targets from './home/Welcome/Targets';
import HRTargetDashboard from './home/Welcome/Targets/HRTargets';
import AddDevelopers from './vendor/AddDevelopers';
import VendorLogin from './vendor/VendorLogin';
import GraphAuth from './GraphAuth/GraphAuth';
import MailTemplateEditor from './ReactMailEditor/MailTemplateEditor';
import Mails from './Mails';
import VerifyDoccument from './hrm/pre-onboardig/onboarding/pre-onboarding/VerifyDocument';
import BDEDetails from './hrm/targets/BDE/BDEDetails';
import BDETracker from './hrm/targets/BDE/BDETracker';
import { ActivityDetails } from './Activities';
import PendingApprovals from './company/policy/PendingApprovals';
import ExitReasons from './Organization/Employees/Exits/ExitReasons';

export const routes = {
  Welcome,
  Dashboard,
  Login,
  TimesheetForm,
  TimesheetMain,
  Projects,
  Users,
  Access,
  Routings,
  Invoice,
  PaidInvoices,
  PendingInvoicesToSend,
  InvoiceMaster,
  MapDesignations,
  UserLogins,
  SortlistedCandidates,
  FixedBidInvoice,
  EmailTemplates,
  EmailKeysMaps,
  InvoiceReports,
  CreatePages,
  BulkMails,
  Policy,
  PolicyCategory,
  UserPolicy,
  Clients,
  GenrateSalarySlip,
  Departments,
  Experiance,
  Releaving,
  Resumes,
  EmployeeProjects,
  SendCV,
  CurrentOpenings,
  AvailableSlots,
  BulkMailVender,
  Files,
  TeamManagment,
  ProjectDashboard,
  OfferLetterTemplate,
  candidates,
  Screening,
  TestComponent,
  HrRound,
  LevelOne,
  WorkFlowRoutes,
  LevelTwo,
  LevelThree,
  LevelFour,
  ManagerRound,
  SalaryRound,
  PreOnboarding,
  OfferLetter,
  VerifyDoccument,
  OrganizationSummary,
  OrganizationAnalysis,
  OrganizationTree,
  EmployeeDirectory,
  LoginFailed,
  LoginHistory,
  LoginRegistration,
  ContingentSummary,
  WorkType,
  DottedLineManager,
  EmployeeDefaults,
  EmployeeNumber,
  IDCard,
  QualifiedCandidates,
  Roles,
  PersonalInfo,
  EmployeeTimeline,
  Wall,
  ProfilesApprovals,
  PastChanges,
  CompleteProbationAction,
  EvaluationInProcess,
  InProbation,
  ProbationFeedbackForm,
  ProbationPolicy,
  PrivateProfiles,
  ApprovalLeaves,
  CompOffs,
  LeaveEncashment,
  Overtime,
  PartialDay,
  Regularization,
  ShiftandWeeklyOff,
  WebClockIn,
  WfhOD,
  BulkRegularization,
  CaptureScheme,
  CaptureSchemeAllocation,
  TrackingPolicy,
  TrackingPolicyAllocation,
  LeastHourWorked,
  MostHourWorked,
  MostBreakTaken,
  OvertimeHours,
  LeaveBalanceAvailable,
  MostLeaveTaken,
  UnplanedLeaveTaken,
  AttendanceSummary,
  LeaveSummary,
  IntialAdjustments,
  LeavePlans,
  LeaveTypes,
  FailedTest,
  CompletedTest,
  AllTest,
  OvertimePolicy,
  OvertimePolicyAllocations,
  PayCodes,
  LeaveReports,
  DeviceClockingSummary,
  SyncToolsInstallations,
  Employees,
  GeoLocations,
  General,
  ShiftAllowanceAssigment,
  ShiftWeeklyOffRulesAssignments,
  ShiftWeeklyOffsAssigment,
  ShiftBoard,
  ShiftRotation,
  ShiftAllowanceCode,
  ShiftAllowancePolicy,
  Shifts,
  ShiftWeeklyOffRules,
  WeeklyOffs,
  AttendanceCaptureScheme,
  AttendanceNumber,
  AttendanceTrackingPolicy,
  BusinessUnit,
  ExpencesPolicy,
  HolidayList,
  LegalEntity,
  Locations,
  NoticePeriod,
  TaxRegime,
  TimeType,
  WorkflowList,
  ProjectTeams,
  ProjectTask,
  EmailTemplateMapping,
  JobId,
  OnlyOfficeFileEditor,
  Targets,
  HRTargetDashboard,
  GraphAuth,
  MailTemplateEditor,
  Mails,
  BDEDetails,
  BDETracker,
  ExitReasons,
  PendingApprovals,
  ...PayRollRoutes,
  ...Organization,
  ...HRMRoutes,
  ...MyFinanceRoutes,
  ...Leads,
  ...Leaves,
  ...VendorRoutes,
  ...PerformanceRoutes
};

export const getAccess = async (dispatch) => {
  const appAccess = await dispatch(action.getAccess());
  const tabs = await dispatch(action.getTabs());
  const routesConfig = [];

  appAccess.forEach(({ componentName, routeUrl, list }) => {
    list?.forEach(element => {
      element?.list?.forEach(ele => {
        if (ele?.routeUrl) {
          routesConfig.push({
            component: routes[ele?.componentName],
            path: ele?.routeUrl,
          })
        }
      });
      if (element?.routeUrl) {
        routesConfig.push({
          component: routes[element?.componentName],
          path: element?.routeUrl,
        })
      }
    })
    if (routeUrl) {
      routesConfig.push({
        component: routes[componentName],
        path: routeUrl,
      });
    }
  })
  tabs.forEach(({ componentName, routeUrl }) => {
    if (routeUrl) {
      routesConfig.push({
        component: routes[componentName],
        path: routeUrl,
      })
    }
  })

  return routesConfig
};

export default [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/change-password',
    component: forgotPassword,
  },
  {
    path: '/job-openings',
    component: JobOpenings,
  },
  {
    path: '/apply/:id',
    component: JobDetials,
  },
  {
    path: '/preonboarding/documents',
    component: Documents,
  },
  {
    path: '/login/candidate',
    component: LoginCandidate,
  },
  {
    path: '/login_candidate',
    component: LoginCandidate,
  },
  {
    path: '/instructions/:id',
    component: Instructions,
  },
  {
    path: '/online-exam/:id',
    component: OnlineExamRoutes,
  },
  {
    path: '/vendor-registration',
    component: VendoRegistrationForm,
  },
  {
    path: '/add-developers',
    component: AddDevelopers,
  },
  {
    path: '/vendor-login',
    component: VendorLogin,
  },
  {
    path: '/success',
    component: SuccessMessage,
  },
  {
    path: '/timesheet',
    component: TimesheetMain,
  },
  {
    path: '/timesheet/*',
    component: TimesheetMain,
  }
];

export const extraRoutes = [
  {
    path: '/profile',
    component: profile,
  },
  {
    path: '/activities/:activityType/:activityId',
    component: ActivityDetails,
  }
]
